import { Trans } from '@lingui/react/macro';
import { brands } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { customerRoutes } from 'noddi-util';
import { useLocation } from 'react-router-dom';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';

const CARGLASS_BANNER_PATHS: string[] = [
  customerRoutes.newBookingAddress.getPath(),
  customerRoutes.newBookingCars.getPath()
];

export const CarglassInfoBanner = () => {
  const { currentBrand } = useCurrentBrand();
  const { pathname } = useLocation();

  if (currentBrand !== brands.carglass || !CARGLASS_BANNER_PATHS.includes(pathname)) {
    return null;
  }

  return (
    <div className='rounded-lg border border-blue-200 bg-blue-50 p-4'>
      <div className='flex gap-3'>
        <NoddiIcon name='Info' size='small' className='mt-0.5 shrink-0 text-blue-600' />
        <span className='text-sm text-blue-800'>
          <Trans>
            This service is only for mobile stone chip repair, delivered to your location. For other services, visit{' '}
            <a href='https://carglass.no' className='underline'>
              carglass.no
            </a>
          </Trans>
        </span>
      </div>
    </div>
  );
};
